module.exports = __webpack_public_path__ + "media/static/icons/icon-point--red-f73dba537ccd42ddf7d1f5bb20c5b202.svg";